const mrqTabs = {
  key: "MANUALREVIEW",
  label: "Human In The Loop",
};

export { mrqTabs };
